import { ROUTER_NAVIGATION } from '@ngrx/router-store';

import { DictionaryListDto, ICountryStatesDto,
    SubscribableEditionComboboxItemDto, LookupDto } from '@shared/service-proxies/service-proxies';

import * as actions from './actions';

export interface StateHistory {
    previous: string;
    current: string;
}

export interface PageState {
    correlationIds: string[];
}

export interface State {
    localization: string;
    phoneMask: (string | RegExp)[];
    dateFormat: string;
    dateFormatShort: string;
    stateHistory: StateHistory;
    states: ICountryStatesDto[] | undefined;
    industryTypes: DictionaryListDto[] | undefined;
    accountTypes: DictionaryListDto[] | undefined;
    geographicRegions: DictionaryListDto[] | undefined;
    transactionTypes: string[] | undefined;
    customerTypes: string[] | undefined;
    unitsOfMeasure: string[] | undefined;
    suffixes: string[] | undefined;
    editions: SubscribableEditionComboboxItemDto[] | undefined;
    frequencyOptions: LookupDto[] | undefined;
    pageState: PageState;
}

export const initialState: State = {
    localization: '',
    phoneMask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    dateFormat: 'MM/dd/yyyy hh:mm a',
    dateFormatShort: 'MM/dd/yyyy',
    stateHistory: {
        previous: undefined,
        current: undefined
    },
    states: undefined,
    accountTypes: undefined,
    geographicRegions: undefined,
    industryTypes: undefined,
    transactionTypes: undefined,
    customerTypes: undefined,
    unitsOfMeasure: undefined,
    suffixes: undefined,
    editions: undefined,
    frequencyOptions: undefined,
    pageState: {
        correlationIds: []
    }
};

const _getPhoneMask = (localization: string): (string | RegExp)[] => {
    // TODO: implement
    return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
};

export function reducer(
    state = initialState,
    action: actions.Actions
): State {
    switch (action.type) {
        case actions.LOCALISATION_CHANGED:
            return {
                ...state,
                localization: action.payload,
                phoneMask: _getPhoneMask(action.payload)
            };
        case ROUTER_NAVIGATION:
            return {
                ...state,
                stateHistory: {
                    previous: state.stateHistory.current,
                    current: action.payload.routerState.url
                }
            };
        case actions.STATES_LOADED:
            return {
                ...state,
                states: action.payload
            };
        case actions.ACCOUNT_TYPES_LOADED:
            return {
                ...state,
                accountTypes: action.payload
            };
        case actions.LOAD_CUSTOMER_TYPES_SUCCEEDED:
            return {
                ...state,
                customerTypes: action.payload
            };
        case actions.INDUSTRY_TYPES_LOADED:
            return {
                ...state,
                industryTypes: action.payload
            };
        case actions.GEOGRAPHIC_REGIONS_LOADED:
            return {
                ...state,
                geographicRegions: action.payload
            };
        case actions.TRANSACTION_TYPES_LOADED:
            return {
                ...state,
                transactionTypes: action.payload
            };
        case actions.LOAD_SUFFIXES_SUCCEEDED:
            return {
                ...state,
                suffixes: action.payload
            };
        case actions.LOAD_UNITS_OF_MEASURE_SUCCEEDED:
            return {
                ...state,
                unitsOfMeasure: action.payload
            };
        case actions.EDITIONS_LOADED:
            return {
                ...state,
                editions: action.payload
            };
        case actions.FREQUENCY_OPTIONS_LOADED:
            return {
                ...state,
                frequencyOptions: action.payload
            };
        case actions.ADD_CORRELATION_ID_IN_PAGE_STATE:
            return {
                ...state,
                pageState: {
                    ...state.pageState,
                    correlationIds: [...state.pageState.correlationIds, action.correlationId]
                }
            };
        case actions.CLEAR_CORRELATION_IDS_IN_PAGE_STATE:
            return {
                ...state,
                pageState: {
                    correlationIds: []
                }
            };
        default: return state;
    }
};

export const getPhoneMask = (state: State) => state.phoneMask;
export const getDateFormat = (state: State) => state.dateFormat;
export const getStates = (state: State) => state.states;
export const getPageState = (state: State) => state.pageState;
